import React from "react";

interface ScannerToggleProps {
  isManualSearch: boolean;
  setIsManualSearch: (value: boolean) => void;
  searchCallBack: (value: string) => void;
}

const ScannerToggle: React.FC<ScannerToggleProps> = ({
  isManualSearch,
  setIsManualSearch,
  searchCallBack,
}) => {
    console.log('isManualSearch', isManualSearch)
  return (
    <div className="d-flex align-items-center mt-md-0 mt-1 ms-lg-1 ps-lg-1">
      <span className="fw-600 secondary-color fs-md-16 fs-14 mx-1">Scanner</span>
      <label className="fw-600 secondary-color fs-md-16 fs-14 me-2 mb-0">No</label>
      <div className="form-check form-switch my-auto">
        <input
          className="form-check-input px-md-3"
          type="checkbox"
          role="switch"
          id="scannerSwitch"
          checked={!isManualSearch}
          onChange={(e) => {
            const checked = e.currentTarget.checked;
            setIsManualSearch(!checked);
            searchCallBack("");
          }}
        />
      </div>
      <label className="fw-600 secondary-color fs-md-16 fs-14 ms-2 mb-0">Yes</label>
    </div>
  );
};

export default ScannerToggle;
